export const ApiPaths = {
    GET_CONFIGURATION: "/api/public/configuration",
    GET_TOKEN: "/api/public/token",
    FORGOT_PASSWORD: "/api/account/password/forgot",
    FORGOT_USERNAME: "/api/account/username/forgot",
    PASSWORD_RESET: "/api/account/password/reset",
    PASSWORD_RESET_AUTH: "/api/account/password/reset/auth",
    VA_GET_CASES: "/api/onlinetaxexpert",
    REGISTER: "/api/account",
    ACCOUNT_PROFILE: "/api/accounts",
    UPDATE_ACCOUNT_LANGUAGE: "/api/account/language",
    SEND_COMPLETE_REGISTRATION_REQUEST_EMAIL: "/api/account/sendCompleteRegistrationRequestEmail",
    UPDATE_PASSWORD: "/api/accounts/__AID__/password",
    HEARTBEAT: "/api/public/configuration/heartbeat",
    GET_SECONDARY_AUTHENTICATION: '/api/account/authenticationfactors',
    RESET_SECONDARY_AUTHENTICATION: '/api/account/authenticationfactors',
    
    // Account Recovery
    GET_RECOVERY_TOKEN: (username) => `/api/accountupdate/token?username=${encodeURIComponent(username)}`,
    VERIFY_USER: '/api/accountupdate/verify',
    UPDATE_EMAIL: '/api/accountupdate',
};